import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CourseSearchFilterPill } from '../../../models/course-search-filter.models';
import { CourseSearchFilterPillComponent } from '../course-search-filter-pill/course-search-filter-pill.component';

@Component({
	selector: 'uc-course-search-filter-pills',
	templateUrl: './course-search-filter-pills.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, CourseSearchFilterPillComponent],
})
export class CourseSearchFilterPillsComponent {
	filterPills = input.required<CourseSearchFilterPill[]>();

	removePill = output<CourseSearchFilterPill>();
	resetFilters = output<void>();

	onRemovePill(pill: CourseSearchFilterPill) {
		this.removePill.emit(pill);
	}

	onResetFilters() {
		this.resetFilters.emit();
	}
}
